import { Flex } from '@mantine/core'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { useAdapter } from '@/components/Adapter'
import { DAY_FORMATE } from '@/constants/index'
import { DateRangePickerDesktop, DateRangePickerMobile } from '@gate/gui-business'
import { useTranslation } from 'next-i18next'

export type FundingDateValueType = [Date | null, Date | null]

interface FundingDateProps {
  fundingDateVal: FundingDateValueType
  handleSelectFundingDateVal: (val: FundingDateValueType) => void
}

const FundingDate: React.FC<FundingDateProps> = ({ fundingDateVal, handleSelectFundingDateVal }) => {
  const { isH5 } = useAdapter()
  const { t } = useTranslation()

  return (
    <Flex>
      {isH5 ? (
        <DateRangePickerMobile
          cancelLabel={t('P.Cancel') + ''}
          confirmLabel={t('p.confirm', { ns: 'fundraising' }) + ''}
          size="md"
          placeholder={t('p.start.time', { ns: 'fundraising' }) + ''}
          endTimePlaceholder={t('p.end.time', { ns: 'fundraising' }) + ''}
          value={fundingDateVal}
          inputFormat={DAY_FORMATE}
          onClear={() => handleSelectFundingDateVal([null, null])}
          onChange={handleSelectFundingDateVal}
          styles={{
            inputWrapper: {
              '.mantine-GateInputGroup-input': {
                paddingRight: '38px',
              },
            },
          }}
        />
      ) : (
        <DateRangePickerDesktop
          size="md"
          w={135}
          placeholder={t('p.start.time', { ns: 'fundraising' }) + ''}
          endTimePlaceholder={t('p.end.time', { ns: 'fundraising' }) + ''}
          value={fundingDateVal}
          allowSingleDateInRange
          onChange={handleSelectFundingDateVal}
          inputFormat={DAY_FORMATE}
          onClear={() => handleSelectFundingDateVal([null, null])}
          styles={{
            input: {
              paddingRight: '38px',
            },
          }}
        />
      )}
    </Flex>
  )
}

export default observer(FundingDate)
